import { ButtonSize, ButtonType } from "@/components/ui/button/button.type";
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from "@/components/ui/drawer";
import { ReactNode } from "react";
import { Button } from "./ui/button/button";

interface ActionProps {
  title: string;
  description: string;
  children: ReactNode;
  includeActionButton?: boolean;
  buttonLabel?: string;
  drawerParams?: any;
  onClose?: () => void;
}
export const Bottomsheet = ({
  title,
  description,
  children,
  buttonLabel,
  drawerParams,
  onClose,
}: ActionProps) => {
  return (
    <div className="feature-container flex w-full flex-col items-center">
      <Drawer {...drawerParams}>
        {buttonLabel && (
          <DrawerTrigger className="flex w-full flex-col items-center justify-center">
            <Button
              label={buttonLabel}
              onClick={() => {}}
              type={ButtonType.danger}
              size={ButtonSize.small}
              widthFull
            />
          </DrawerTrigger>
        )}
        <DrawerContent>
          <DrawerHeader>
            <DrawerTitle>{title}</DrawerTitle>
            <DrawerDescription>{description}</DrawerDescription>
          </DrawerHeader>
          {children}
          <DrawerFooter>
            <DrawerClose
              onClick={() => {
                onClose?.();
              }}>
              <div className="w-full rounded-md border border-gray-800 bg-bg-tertiary p-2 text-text-light">
                Close
              </div>
            </DrawerClose>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </div>
  );
};
